export interface MediaLandscapeFilters {
  /** Inclusive month bound, `YYYY-MM`. */
  from: string;
  /** Inclusive month bound, `YYYY-MM`. */
  to: string;
  /** Selected advertiser names. Empty means every advertiser. */
  advertisers: string[];
}

export function availableMonths(rows: Array<{ month: string }>): string[] {
  return Array.from(new Set(rows.map((r) => r.month))).sort();
}

/** Months are `YYYY-MM`, so string comparison is chronological and needs no `Date`. */
export function normaliseRange(from: string, to: string): [string, string] {
  return from <= to ? [from, to] : [to, from];
}

export function resolveAdvertisers(all: string[], selected: string[]): string[] {
  if (selected.length === 0) return all;
  const wanted = new Set(selected);
  return all.filter((name) => wanted.has(name));
}

export function inMonthRange<T extends { month: string }>(
  rows: T[],
  from: string,
  to: string,
): T[] {
  const [lo, hi] = normaliseRange(from, to);
  return rows.filter((r) => r.month >= lo && r.month <= hi);
}
